import qs from "qs";
import { useLocation } from "react-router-dom";

export const useQuery = () => {
  const location = useLocation();
  const query =
    location.search.charAt(0) === "?" ? location.search.substring(1) : location;

  const makeQuery = (newQuery) => {
    const newQueries = Object.entries(newQuery).map(
      ([key, value]) => `${key}=${encodeURIComponent(value)}`
    );
    return newQueries.join("&");
  };

  const setQuery = (newQuery) => {
    const queries = makeQuery(newQuery);
    return `${location.pathname}?${queries}`;
  };

  const getQuery = () => {
    return qs.parse(query);
  };

  return { getQuery, setQuery, makeQuery };
};
